/**
 * Sharing route — thin wrapper over the presentational `DocumentSharing`
 * governance surface. The active tab is driven by the `?tab=` query param and
 * changes push to the router. Sharing is not yet backed, so `onShare` is a
 * no-op; the route only wires navigation and reads data from the vault context.
 */
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { DocumentSharing } from "#components/DocumentSharing";
import * as styles from "../styles_vanilla.css";
import { useVaultData } from "../VaultProvider";
import { VaultPageHeader } from "./VaultPageHeader";
import type { SharingView } from "#components/DocumentSharing/types";

export const SharingRoute = ({ basePath }: { basePath: string }) => {
  const history = useHistory();
  const location = useLocation();
  const { documents, shareLog, clients, spaces, reference } = useVaultData();

  const view = (new URLSearchParams(location.search).get("tab") as SharingView) || "rules";

  return (
    <>
      <VaultPageHeader title="Sharing" />
      <div className={styles.content.wide}>
        <DocumentSharing
          documents={documents}
          log={shareLog}
          clients={clients}
          spaces={spaces}
          reference={reference}
          view={view}
          onViewChange={(v) => history.push(`${basePath}/sharing?tab=${v}`)}
          onViewInDocuments={() => history.push(`${basePath}/documents`)}
        />
      </div>
    </>
  );
};
